import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, shareReplay, switchMap } from "rxjs";
import { environment } from "../../environments/environment";
import { BaseService } from "./base.service";
import { FilterChip } from "../models/filter-chip";
import { Group, GroupMembership } from "../models/group";
import { User } from "../models/user";
import { Effort, EffortOwner } from "../models/effort";

@Injectable({ providedIn: 'root' })
export class EffortOwnersService extends BaseService {
    private effortsSubject = new BehaviorSubject<EffortOwner[]>([]);
    efforts$ = this.effortsSubject.asObservable();

    private sourceUpdatedSubject = new BehaviorSubject<boolean>(false);
    sourceUpdated$ = this.sourceUpdatedSubject.asObservable();

    constructor(private http: HttpClient) {
        super();
    }

    fetchEffortOwners() {
        this.http.get<EffortOwner[]>(environment.apiUrl + 'efforts/owners/search').subscribe(owners => {
            this.effortsSubject.next(owners);
        });
    }

    addEffortOwners(effort: Effort, users: User[]) {
        let memberships = users.map(u => <EffortOwner>{ effortId: effort.id, userId: u.id});
        this.http.post(environment.apiUrl + `efforts/${effort.id}/owners`, memberships).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }

    deleteEffortOwner(effortId: number, userId: number) {
        this.http.delete(environment.apiUrl + `efforts/${effortId}/owners/${userId}`).subscribe(() => {
            this.sourceUpdatedSubject.next(true);
        });
    }
}